import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CaseSelector from "./components/CaseSelector";

const pub = (p) => `${process.env.PUBLIC_URL}${p}`;


export default function HeroPage() {

  const [activeIndex, setActiveIndex] = useState(0);

  const images = [
    pub("/paper/fig3.png"),
    pub("/paper/fig4.png"),
    //pub("/results/results3.png"),
  ];
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [hash]);

  return (
    <main id="top">
      {/* ===== Hero Section ===== */}
      <section className="hero is-light is-medium" id="hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-2">
              Design &amp; Evaluation of Generative Agent-based Platform
              <br /> for Human-Assistant Interaction Research
            </h1>

            <h2 className="subtitle is-6 mt-6">
              <a href="mailto:zix222@lehigh.edu">Ziyi (Selina) Xuan</a><span style={{color: '#007bff', fontSize: '0.8em', verticalAlign: 'super'}}>1</span>,{" "}
              <a href="mailto:yiw423@lehigh.edu">Yiwen Wu</a><span style={{color: '#007bff', fontSize: '0.8em', verticalAlign: 'super'}}>1</span>, Xuhai Xu<span style={{color: '#ff8c00', fontSize: '0.8em', verticalAlign: 'super'}}>1</span>, Vinod Namboodiri<span style={{color: '#007bff', fontSize: '0.8em', verticalAlign: 'super'}}>1</span>, Mooi Choo Chuah<span style={{color: '#007bff', fontSize: '0.8em', verticalAlign: 'super'}}>1</span>,{" "}
              <a href="mailto:yuyang@lehigh.edu">Yu Yang</a><span style={{color: '#007bff', fontSize: '0.8em', verticalAlign: 'super'}}>1</span>
            </h2>
            <div className="is-size-6" style={{textAlign: 'center'}}>
              <div style={{paddingLeft: '24px'}}>
                <span style={{color: '#007bff', marginRight: '8px', display: 'inline-block', transform: 'rotate(90deg)'}}>▲</span>Lehigh University
              </div>
              <div>
                <span style={{color: '#ff8c00', marginRight: '8px', display: 'inline-block', transform: 'rotate(90deg)'}}>▲</span>Columbia University
              </div>
            </div>

            <div className="buttons is-centered mt-6">
              <a className="button" href="https://arxiv.org/abs/2505.09938" target="_blank" rel="noopener noreferrer" style={{backgroundColor: '#4a4a4a', color: 'white', border: 'none'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                </svg>
                Paper
              </a>
              <a className="button" href="#demo" style={{backgroundColor: '#4a4a4a', color: 'white', border: 'none'}}>▶︎ Demo</a>
              <a className="button" href="https://github.com/DASHLab/GIDEA" target="_blank" rel="noopener noreferrer" style={{backgroundColor: '#4a4a4a', color: 'white', border: 'none'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
                GitHub
              </a>
            </div>

            {/* Scrollable teaser gallery (two slides) */}
              <figure
                className="image mt-6"
                style={{ maxWidth: "1200px", margin: "0 auto" }}  // clamp width & center
              >
              <img
                src={pub("/paper/fig1_pipeline.png")}
                alt="HCI workflow vs GIDEA overview"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px",
                  border: "1px solid #e5e7eb"
                }}
              />
              <figcaption className="is-size-7 has-text-grey mt-2">
                Teaser: Conventional HCI workflow vs. GIDEA's generative simulation.
              </figcaption>
            </figure>

          </div>
        </div>
      </section>

      {/* ===== Abstract ===== */}
      <section id="abstract" className="section">
        <div className="container content">
          <h2 className="title is-3 has-text-centered">Abstract</h2>
          <p>
            GIDEA simulates human-assistant interaction studies by encoding protocols, personas, and environment
            state into structured prompts that drive role-separated LLM agents (assistant vs. avatar). We replicate
            ten published studies across personalization, proactivity, interruptibility, and user control, achieving
            high semantic alignment with original findings and reproducing key behavioral patterns (e.g., timing
            sensitivity). We discuss limitations (over-responsiveness, narrower metaphor diversity) and outline
            opportunities for embodied contexts, multimodal sensing, and improved factuality. As a reproducible,
            traceable testbed, GIDEA complements human-subject research by reducing iteration costs and refining
            hypotheses prior to deployment.
          </p>
        </div>
      </section>

      {/* ===== Demo Video ===== */}
      <section id="demo" className="section has-background-light">
        <div className="container content">
          <h2 className="title is-3 has-text-centered">Demo</h2>
          <p className="is-size-6 has-text-grey has-text-centered">
            Short walkthrough of the platform and a sample replication.
          </p>

          <DemoPlayer />
        </div>
      </section>

      {/* ===== Caregiving Example ===== */}
      <section id="carelink" className="section">
        <div className="container">
          <div className="columns is-vcentered is-variable is-6">
            <div className="column is-two-fifths content">
              <p
                className="is-size-7 has-text-weight-bold mb-2"
                style={{ color: "#2f6f65", letterSpacing: "0.08em", textTransform: "uppercase" }}
              >
                Example usage
              </p>
              <h2 className="title is-3">AI-assisted senior care with CareLink Companion</h2>
              <p>
                CareLink Companion shows how GIDEA-style human-assistant research can be applied to a caregiving
                workflow. A wearable device supports the elder in the moment, the phone app mirrors important
                information, and CareLink Center helps caregivers review alerts and care events.
              </p>
              <div className="buttons mt-5">
                <a
                  className="button is-dark"
                  href={pub("/carelink/")}
                  style={{ border: "none" }}
                >
                  Open CareLink User Guide
                </a>
                <a
                  className="button is-light"
                  href={pub("/carelink/#request")}
                >
                  Request a Feature
                </a>
              </div>
            </div>
            <div className="column">
              <div
                className="box"
                style={{
                  border: "1px solid #dce7e3",
                  borderRadius: "10px",
                  boxShadow: "0 18px 48px rgba(24, 48, 47, 0.10)"
                }}
              >
                <h3 className="title is-4 mb-4">Morning medication support</h3>
                <div className="columns is-variable is-3">
                  <div className="column">
                    <div className="notification" style={{ backgroundColor: "#eaf5f1" }}>
                      <p className="has-text-weight-bold mb-2">1. Wearable reminder</p>
                      <p>The elder hears a gentle medication reminder and confirms by voice or button.</p>
                    </div>
                  </div>
                  <div className="column">
                    <div className="notification" style={{ backgroundColor: "#eef4ff" }}>
                      <p className="has-text-weight-bold mb-2">2. Phone app mirror</p>
                      <p>The app shows a large card with the medication name, time, and Taken status.</p>
                    </div>
                  </div>
                  <div className="column">
                    <div className="notification" style={{ backgroundColor: "#fff4e4" }}>
                      <p className="has-text-weight-bold mb-2">3. Caregiver review</p>
                      <p>CareLink Center logs the event and alerts caregivers if the dose is missed or unusual.</p>
                    </div>
                  </div>
                </div>
                <p className="has-text-grey">
                  The guide covers check-ins, relationship prompts, reading assistance, emergency help, trend reports,
                  privacy controls, and the GPT to researcher to Codex feature workflow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Method ===== */}
      <section id="method" className="section">
        <div className="container">
          <h2 className="title is-3 has-text-centered">Method Overview</h2>
          <div className="columns is-vcentered">
            <div className="column is-half">
              <figure>
                <img src={pub("workflow.png")} alt="GIDEA pipeline" />
                <figcaption className="is-size-7 has-text-grey mt-1">
                  Simulation workflow of GIDEA.
                </figcaption>
              </figure>
            </div>
            <div className="column is-half content">
              <p>
                GIDEA mirrors standard HCI workflows while virtualizing data collection. Researchers encode objectives,
                metrics, and role separation into an Interaction Knowledge schema; define TIPI-based personas, narratives,
                and salient devices in Context Setup; and let two independent LLM roles run multi-turn dialogues over
                evolving environment state. Knowledge isolation prevents leakage; memory snapshots and device context
                bound generations; logs enable traceable analysis and reproducible comparisons across study variants.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Results ===== */}
      <section id="results" className="section has-background-light">
        <div className="container">
          <h2 className="title is-3 has-text-centered">Results at a Glance</h2>
          <div className="columns is-vcentered">
            <div className="column is-half">
              <figure>
                <div
                  style={{
                    position: "relative",
                    maxWidth: "600px",       // match your original image width
                    margin: "0 auto",        // center horizontally
                    overflow: "hidden",      // hide other slides
                    borderRadius: "10px",
                    border: "1px solid #e5e7eb"
                  }}
                >
                  {/* Slides */}
                  <div
                    style={{
                      display: "flex",
                      transition: "transform 0.6s ease",
                      transform: `translateX(-${activeIndex * 100}%)`
                    }}
                  >
                    {images.map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        alt={`Slide ${i + 1}`}
                        style={{
                          width: "100%",
                          flex: "0 0 100%",
                          height: "auto"
                        }}
                      />
                    ))}
                  </div>

                </div>
                {/* Dots */}
                  <div style={{ textAlign: "center", marginTop: "12px" }}>
                    {images.map((_, i) => (
                      <span
                        key={i}
                        onClick={() => setActiveIndex(i)}
                        style={{
                          display: "inline-block",
                          width: "10px",
                          height: "10px",
                          margin: "0 6px",
                          borderRadius: "50%",
                          background: activeIndex === i ? "#333" : "#ccc",
                          cursor: "pointer"
                        }}
                      />
                    ))}
                  </div>
                <figcaption className="is-size-7 has-text-grey mt-1">
                  1. Semantic similarity scores comparing simulated and original study responses for each research question (RQ) across
10 case studies. 2. Semantic similarity by theme and study mode across 10 replications.
                </figcaption>
              </figure>
            </div>
            <div className="column is-half content">
              <ul>
                <li>High semantic alignment overall; personalization &amp; proactivity strongest, user control harder.</li>
                <li>Interview/storyboard modes outperform WoZ where spontaneity dominates.</li>
                <li>GIDEA matches timing sensitivity and framing trends; metaphor diversity is narrower.</li>
                <li>Over-responsiveness vs. humans observed; future work targets embodied/multimodal context.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Case Studies (Selector) ===== */}
      <section id="cases" className="section">
        <div className="container content">
          <h2 className="title is-3 has-text-centered">Case Studies</h2>
          <p className="has-text-grey has-text-centered">
            Browse by theme and open a study to view details below.
          </p>

          {/* Inline mode (sticky bar optional via style wrapper) */}
          <div className="box" style={{ position: "sticky", top: "64px", zIndex: 30, background: "#fff" }}>
            {/* the tabs + buttons are inside the component; this wrapper just provides a sticky look */}
            <CaseSelector mode="inline" />
          </div>
        </div>
      </section>

      {/* ===== BibTeX ===== */}
      <section id="bibtex" className="section has-background-light">
        <div className="container content">
          <h2 className="title is-3 has-text-centered">BibTeX</h2>
          <p className="has-text-centered has-text-grey mb-4">
            If you find GIDEA useful in your research, we would appreciate it if you consider citing our work:
          </p>
          <BibTeXCard />
        </div>
      </section>

      {/* ===== Contact ===== */}
      <section id="contact" className="section">
        <div className="container content">
          <h2 className="title is-3 has-text-centered">Contact Us</h2>
          <p className="has-text-centered">
            We'd love to hear from you — collaborate, learn more about GIDEA, or explore research opportunities.
          </p>
          {/* Ziyi */}
          <div className="has-text-centered" style={{marginTop: '3rem'}}>
            <a href="https://selinaxuan.github.io/" style={{color: '#333', textDecoration: 'none'}}>
              Ziyi (Selina) Xuan
            </a>
            <span style={{margin: '0 10px', color: '#666'}}>•</span>
            <a href="mailto:zix222@lehigh.edu" style={{color: '#007bff', textDecoration: 'none'}}>
              zix222@lehigh.edu
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

function BibTeXCard() {
  const [showCopied, setShowCopied] = useState(false);
  
  const bibtexText = `@article{xuan2025design,
  title={Design and Evaluation of Generative Agent-based Platform for Human-Assistant Interaction Research: A Tale of 10 User Studies},
  author={Xuan, Ziyi and Wu, Yiwen and Xu, Xuhai and Namboodiri, Vinod and Chuah, Mooi Choo and Yang, Yu},
  journal={arXiv preprint arXiv:2505.09938},
  year={2025}
}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(bibtexText);
      setShowCopied(true);
      setTimeout(() => setShowCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      marginTop: '1rem' 
    }}>
      <div style={{
        position: 'relative',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '8px',
        padding: '30px',
        maxWidth: '800px',
        width: '100%',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <button
          onClick={handleCopy}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'transparent',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            padding: '6px 8px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Copy to clipboard"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
          </svg>
        </button>
        
        <pre style={{
          margin: 0,
          fontFamily: 'Monaco, Consolas, "Courier New", monospace',
          fontSize: '14px',
          lineHeight: '1.4',
          color: '#333',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}>
          {bibtexText}
        </pre>
        
        {showCopied && (
          <div style={{
            position: 'absolute',
            top: '-40px',
            right: '10px',
            background: '#28a745',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '4px',
            fontSize: '14px',
            zIndex: 1000
          }}>
            Copied!
          </div>
        )}
      </div>
    </div>
  );
}

function DemoPlayer() {
  const [playing, setPlaying] = useState(false);

  // 16:9 responsive wrapper that fills container width
  const wrapperStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "1100px",
    margin: "0 auto",
    paddingTop: "56.25%",   // 16:9
    borderRadius: "10px",
    overflow: "hidden",
    border: "1px solid #e5e7eb",
    background: "#000",
  };

  const iframeStyle = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
  };

  // YouTube embed URL (autoplay only after click)
  const ytSrc = `https://www.youtube.com/embed/-KfNkylGOjM?autoplay=1&rel=0&modestbranding=1&playsinline=1&origin=${encodeURIComponent(
    window.location.origin
  )}`;

  if (playing) {
    return (
      <div style={wrapperStyle}>
        <iframe
          title="GIDEA Demo"
          src={ytSrc}
          style={iframeStyle}
          frameBorder="0"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
          allowFullScreen
          referrerPolicy="origin"
        />
      </div>
    );
  }

  // Not playing yet → show custom thumbnail as a button (entire area clickable)
  return (
    <div style={wrapperStyle}>
      <button
        type="button"
        onClick={() => setPlaying(true)}
        aria-label="Play demo video"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          cursor: "pointer",
          border: 0,
          padding: 0,
          background: "transparent",
        }}
      >
        <img
          src={process.env.PUBLIC_URL + "/cover.png"} // <-- your OG image in /public
          alt="Play demo video"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        {/* Play icon */}
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "rgba(0,0,0,.6)",
            borderRadius: "50%",
            width: 72,
            height: 72,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" width="36" height="36">
            <path d="M8 5v14l11-7z" />
          </svg>
        </span>
      </button>
    </div>
  );
}
